"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemberOrTeamStatus = exports.getChoicesValuesWithIsCompleteStatus = void 0;
const get_value_1 = require("../safe-field-value/status-field/get-value");
const primitives_1 = require("../safe-field-value/type-checking/primitives");
const getChoicesValuesWithIsCompleteStatus = (statusField) => {
    var _a, _b;
    const choices = (_b = (_a = statusField.params) === null || _a === void 0 ? void 0 : _a.choices) !== null && _b !== void 0 ? _b : [];
    return choices
        .filter(({ is_complete }) => is_complete)
        .map(({ value }) => value);
};
exports.getChoicesValuesWithIsCompleteStatus = getChoicesValuesWithIsCompleteStatus;
const getMemberOrTeamStatus = (memberOrTeam) => {
    var _a;
    if ((0, primitives_1.isStringValue)(memberOrTeam === null || memberOrTeam === void 0 ? void 0 : memberOrTeam.status)) {
        return (0, get_value_1.generateStatusFieldValue)({ value: (memberOrTeam === null || memberOrTeam === void 0 ? void 0 : memberOrTeam.status) || "" });
    }
    return (_a = memberOrTeam === null || memberOrTeam === void 0 ? void 0 : memberOrTeam.status) !== null && _a !== void 0 ? _a : (0, get_value_1.getStatusFieldEmptyValue)();
};
exports.getMemberOrTeamStatus = getMemberOrTeamStatus;
